import { createSlice } from '@reduxjs/toolkit';
import initialState from './company.initialState';
import { addNewCompany, editCompany, fetchCompanies } from './company.actions';

export const companySlice = createSlice({
  name: 'companySlice',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchCompanies.pending, (state) => {
        state.companies.loading = true;
        state.companies.error = null;
      })
      .addCase(fetchCompanies.rejected, (state, action) => {
        state.companies.loading = false;
        state.companies.error = action.payload;
      })
      .addCase(fetchCompanies.fulfilled, (state, action) => {
        const { companies, total } = action.payload;
        state.companies.data = companies;
        state.companies.total = total;
        state.companies.loading = false;
        state.companies.error = null;
      })
      .addCase(addNewCompany.pending, (state) => {
        state.addNewCompany.loading = true;
        state.addNewCompany.error = null;
      })
      .addCase(addNewCompany.rejected, (state, action) => {
        state.addNewCompany.loading = false;
        state.addNewCompany.error = action.payload;
        state.addNewCompany.data = {};
      })
      .addCase(addNewCompany.fulfilled, (state, action) => {
        state.addNewCompany.data = action.payload;
        state.addNewCompany.loading = false;
        state.addNewCompany.error = null;
      })
      .addCase(editCompany.pending, (state) => {
        state.editCompany.loading = true;
        state.editCompany.error = null;
      })
      .addCase(editCompany.rejected, (state, action) => {
        state.editCompany.loading = false;
        state.editCompany.error = action.payload;
        state.editCompany.data = {};
      })
      .addCase(editCompany.fulfilled, (state, action) => {
        state.editCompany.data = action.payload;
        state.editCompany.loading = false;
        state.editCompany.error = null;
      });
  },
});
